<div class="p-4" fxLayout="row" fxLayoutAlign="space-between center" mat-dialog-title><span><strong>{{quoteDetails.customerName}}</strong></span> <span><strong>{{quoteDetails.quoteNumber}}</strong></span></div>
<mat-dialog-content class="dialog-content pl-5 pr-5 pt-2 pb-2">
<div class="details-con">
  <div class="grid-con" fxLayout="row">
    <div class="grid-inner-con" fxLayout="row wrap" fxFlex="100">
    <div class="gridItem" fxFlex="100" fxFlex.gt-md="33.33">
      <span fxLayout="row" fxLayoutAlign="start center">
        <span>Opportunity Name:</span>
        <span class="input-field" fxLayout="row" fxLayoutAlign="end center">
          <ng-container *ngIf="!hideOpportunity">{{quoteDetails.quoteInfo && quoteDetails.quoteInfo.opportunityName}}</ng-container>
          <input *ngIf="hideOpportunity" [(ngModel)]="quoteDetails.quoteInfo.opportunityName" (click)="$event.stopImmediatePropagation()"/>
          <mat-icon *ngIf="!hideOpportunity" (click)="hideOpportunity = !hideOpportunity" aria-hidden="false" aria-label="Edit" class="editIcon">edit</mat-icon>
          <mat-icon *ngIf="hideOpportunity" (click)="saveOpportunityName()" aria-hidden="false" aria-label="Save" class="editIcon">save</mat-icon>
      </span></span>
    </div>
<!--    <div class="gridItem" fxFlex="33.33">-->
<!--      <span>-->
<!--        <span>Legal Entity Name:</span> <span>{{quoteDetails.customerName}}</span>-->
<!--      </span>-->
<!--    </div>-->
    <div class="gridItem" fxFlex="33.33">
      <span>
        <span>Credit Status:</span> <span>{{quoteDetails.creditStatus}}</span>
      </span>
    </div>
<!--    <div class="gridItem" fxFlex="33.33">-->
<!--      <span>-->
<!--        <span>Quote Number:</span> <span>{{quoteDetails.quoteNumber}}</span>-->
<!--      </span>-->
<!--    </div>-->
    <div class="gridItem" fxFlex="33.33">
      <span>
        <span>Market:</span> <span>{{quoteDetails.market}}</span>
      </span>
    </div>
    <div class="gridItem" fxFlex="33.33">
      <span>
        <span>Product:</span> <span>{{quoteDetails.product}}</span>
      </span>
    </div>
    <div class="gridItem" fxFlex="33.33">
      <span>
        <span>Swing %:</span> <span>{{quoteDetails.riskSwing}}</span>
      </span>
    </div>
    <div class="gridItem" fxFlex="33.33">
      <span>
        <span>Start Date:</span> <span>{{quoteDetails.startDate | date: "MM/dd/YYYY"}}</span>
      </span>
    </div>
    <div class="gridItem" fxFlex="33.33">
      <span>
        <span>Margin ($/MWh):</span> <span>{{quoteDetails.brokerMargin | number: '1.2-2'}}</span>
      </span>
    </div>
    <div class="gridItem" fxFlex="33.33">
      <span>
        <span>Quote Version: </span> <span>{{quoteDetails.versionDate | date: "MM/dd/YYYY hh:mm:ss a"}}</span>
      </span>
    </div>
    <div class="gridItem">
    <span fxLayout="row" fxLayoutAlign="start center">
      <span>Notes</span>
      <span class="input-field" fxLayout="row" fxLayoutAlign="end center">
          <ng-container *ngIf="!hideCommentAction">{{quoteDetails.quoteInfo && quoteDetails.quoteInfo.userComment}}</ng-container>
          <input *ngIf="hideCommentAction" [ngStyle]="{outline: 'none'}" placeholder="Comments..." [(ngModel)]="quoteDetails.quoteInfo.userComment"/>
          <mat-icon *ngIf="!hideCommentAction" (click)="hideCommentAction = !hideCommentAction" aria-hidden="false" aria-label="Edit" class="editIcon">edit</mat-icon>
          <mat-icon *ngIf="hideCommentAction" (click)="saveQuote()" aria-hidden="false" aria-label="Save" class="editIcon">save</mat-icon>
      </span>
    </span>
      <!--      <span><input [ngStyle]="{border: 'none', outline: 'none'}" [(ngModel)]="quoteDetails.quoteInfo.userComment" placeholder="Comments..."/></span>-->
    </div>
    </div>
  <table class="details-table" fxFlex="100" cellpadding="0">
    <thead>
    <tr>
      <th></th>
      <th><span>Terms (Month)</span></th>
      <th><span>Fixed Price ($/MWh)</span></th>
      <th><span>Term Usage (MWh)</span></th>
      <th><span>End Date</span></th>
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let quoteTerm of quoteDetails.terms; let i=index">
      <td align="center">
        <mat-checkbox size="small" class="radio-btn" name="terms" (change)="termSelected($event.checked, quoteTerm, i)"></mat-checkbox>
      </td>
      <td>
        {{quoteTerm.term}}
      </td>
      <td>
        {{quoteTerm.fixedPrice | number: '1.2-2'}}
      </td>
      <td>
        {{quoteTerm.usage | number}}
      </td>
      <td>
        {{quoteTerm.endDate | date: "MM/dd/YYYY"}}
      </td>
    </tr>
    </tbody>
  </table>
<!--  <table class="details-table" fxFlex="100">-->
<!--    <thead>-->
<!--    <tr>-->
<!--      <th><span>Facility</span></th>-->
<!--      <th><span>Facility Number</span></th>-->
<!--      <th><span>Start Date</span></th>-->
<!--      <th><span>End Date</span></th>-->
<!--      <th><span>Utility</span></th>-->
<!--      <th><span>Billing Type</span></th>-->
<!--    </tr>-->
<!--    </thead>-->
<!--    <tbody>-->
<!--    <tr *ngFor="let facility of quoteDetails.quoteMeterList; let i=index">-->
<!--      <td>{{facility.facilityName}}</td>-->
<!--      <td>{{facility.faclitiyNumber}}</td>-->
<!--      <td>{{facility.startDate | date: "MM/dd/YYYY"}}</td>-->
<!--      <td>{{facility.endDate | date: "MM/dd/YYYY"}}</td>-->
<!--      <td>{{facility.utility}}</td>-->
<!--      <td>{{facility.billType}}</td>-->
<!--    </tr>-->
<!--    </tbody>-->
<!--  </table>-->
    <div class="details-table" fxFlex="100">
      <div class="xScroll">

        <table mat-table [dataSource]="quoteMeterList" matSort class="table table-hover headerTextNowrap">
          <ng-container matColumnDef="quoteMeterFacilityName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Facility Name</th>
            <td mat-cell *matCellDef="let row">{{row.quoteMeterFacilityName}}</td>
          </ng-container>
          <ng-container matColumnDef="quoteMeterFacilityNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Facility Number</th>
            <td mat-cell *matCellDef="let row">{{row.quoteMeterFacilityNumber}}</td>
          </ng-container>
          <ng-container matColumnDef="quoteMeterStartDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
            <td mat-cell *matCellDef="let row">{{row.quoteMeterStartDate | date: "MM/dd/YYYY"}}</td>
          </ng-container>
<!--          <ng-container matColumnDef="quoteMeterEndDate">-->
<!--            <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>-->
<!--            <td mat-cell *matCellDef="let row">{{row.quoteMeterEndDate | date: "MM/dd/YYYY"}}</td>-->
<!--          </ng-container>-->
          <ng-container matColumnDef="quoteMeterUtility">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Utility</th>
            <td mat-cell *matCellDef="let row">{{row.quoteMeterUtility}}</td>
          </ng-container>
          <ng-container matColumnDef="billTypeName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Bill Type</th>
            <td mat-cell *matCellDef="let row">{{row.billTypeName}}</td>
          </ng-container>
          <ng-container matColumnDef="PLC">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>PLC</th>
            <td mat-cell *matCellDef="let row">{{row.PLC && row.PLC.toFixed(2)}}</td>
          </ng-container>
          <ng-container matColumnDef="NSPL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>NSPL</th>
            <td mat-cell *matCellDef="let row">{{row.NSPL && row.NSPL.toFixed(2)}}</td>
          </ng-container>
<!--          <ng-container matColumnDef="startDateType">-->
<!--            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date Type</th>-->
<!--            <td mat-cell *matCellDef="let row">{{row.startDateType}}</td>-->
<!--          </ng-container>-->
<!--          <ng-container matColumnDef="transactionType">-->
<!--            <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction Type</th>-->
<!--            <td mat-cell *matCellDef="let row">{{row.transactionType}}</td>-->
<!--          </ng-container>-->
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <div class="loadingShade" *ngIf="isLoading">
          <mat-spinner></mat-spinner>
        </div>
      </div>
<!--      <mat-paginator [ngStyle]="{backgroundColor: '#f6f6f6'}" [pageSizeOptions]="[5,10,25,100]"></mat-paginator>-->
    </div>

  </div>
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div fxLayout="row" fxLayoutAlign="end center" class="w-100">
    <span class="warning-text flex-grow-1 text-left p-2" *ngIf="termActive.length && !quoteDetails.product">Unable to identify download Contract. Please reach out to your Salesperson.</span>
    <span class="warning-text flex-grow-1 text-left p-2" *ngIf="utilService.isQuoteExpired(quoteDetails.versionDate)">*Requires refreshed pricing. Contact your sales Manager.</span>
    <span class="warning-text flex-grow-1 text-left p-2" *ngIf="!utilService.isQuoteExpired(quoteDetails.versionDate) && !(termActive.length && !quoteDetails.product) && contractDisabled">Due to market volatility, please contact your Sales Manager for executable contracts.</span>
    <!--    <button mat-button color="primary" (click)="saveQuote()">Save Only</button>-->
    <button mat-button mat-raised-button color="primary" (click)="openTermsDetailDialog()">Request Change</button>
    <button mat-button mat-raised-button color="primary" [disabled]="isLoading || !termActive.length || !quoteDetails.product || utilService.isQuoteExpired(quoteDetails.versionDate) || contractDisabled" (click)="openDownloadContractDialog()">Download Contract</button>
    <button mat-button mat-raised-button color="primary" (click)="closeDialog()">Close</button>
  </div>
</mat-dialog-actions>
